@if (isImportScreen) {
<div class="import-container">

  <!-- STEP 1: Download / Upload / Paste -->
  @if (importObj.step === 1 && importObj.records === 0) {
<div class="import-left">

    <!-- Download Template (not shown for grid-import-td) -->
    @if (screenType !== 'grid-import-td') {
<div class="btn-group" (click)="downloadTemp()">
      <button type="button" class="btn btn-sm btn-dark-icon">
        <i class="fa fa-download"></i>
      </button>
      <button type="button" class="btn btn-sm orange-btn">Download Template</button>
    </div>
}

    <!-- Upload Template -->
    @if (showUploadBtn) {
<div class="btn-group" (click)="uploadTemp()">
      <button type="button" class="btn btn-sm btn-dark-icon">
        <i class="fa fa-upload"></i>
      </button>
      <button type="button" class="btn btn-sm orange-btn">
        {{ screenType === 'grid-import-td' ? 'Upload Insurance Feed' : 'Upload Template' }}
      </button>
    </div>
}

    <!-- Paste From Clipboard (not shown for grid-import-td) -->
    @if (screenType !== 'grid-import-td') {
<div class="btn-group" (click)="pasteData()">
      <button type="button" class="btn btn-sm btn-dark-icon">
        <i class="fa fa-clipboard"></i>
      </button>
      <button type="button" class="btn btn-sm orange-btn">Paste From Clipboard</button>
    </div>
}
  </div>
}

  <!-- STEP 2: Cancel / Save / Tags -->
  @if (importObj.step === 2) {
<div class="import-left">

    <div class="btn-group" (click)="openCancelDataLoadConfirmation()">
      <button type="button" class="btn btn-sm btn-dark-icon">
        <i class="fa fa-times"></i>
      </button>
      <button type="button" class="btn btn-sm orange-btn orange-btn-warning">Cancel Data Load</button>
    </div>

    @if (!importObj.saving) {
<div class="btn-group" (click)="!showSaveBtn && save()">
      <button type="button" class="btn btn-sm btn-dark-icon">
        <i class="fa fa-floppy-o"></i>
      </button>
      <button type="button" class="btn btn-sm btn-success"
              [disabled]="showSaveBtn">
        @if (importObj.crudLoading) {
<span>
          <i class="fa fa-spinner fa-pulse"></i>
        </span>
}
        Save Data
      </button>
    </div>
}

    @if (importObj.errorLength > 0) {
<label>Rows With Errors</label>
}
    @if (importObj.errorLength > 0) {
<label
           class="badge error-badge">
      <b>{{ importObj.errorLength }}</b>
    </label>
}

    @if (!importObj.saving) {
<div class="btn-group tag-group">
      <input type="text" class="form-control input-sm tag-input"
             placeholder="Enter Tag No"
             [(ngModel)]="tagNumber"
             maxlength="30">
      <button type="button" class="btn btn-sm btn-success tag-add-btn"
              (click)="addBatchTag(tagNumber)">
        <i class="fa fa-plus"></i>
      </button>
    </div>
}

    @for (tag of batchTags; track $index; let i = $index) {
<div
         class="btn-group btn-group-xs tag-chip"
         [title]="tag">
      <div class="btn btn-default btn-xs tag-label">{{ tag }}</div>
      <div class="btn btn-danger btn-xs" (click)="removeBatchTag(i)">
        <i class="fa fa-times"></i>
      </div>
    </div>
}

    @if (importObj.saving) {
<div class="btn-group">
      <button type="button" class="btn btn-sm btn-dark-icon">
        <i class="fa fa-spinner fa-spin fa-fw"></i>
      </button>
      <button type="button" class="btn btn-sm btn-info">Saving ...</button>
    </div>
}
  </div>
}

  <!-- STEP 3: Success / New Import -->
  @if (importObj.step === 3) {
<div class="import-left">
    <div class="btn-group" (click)="cancel()">
      <button type="button" class="btn btn-sm btn-dark-icon">
        <i class="fa fa-plus"></i>
      </button>
      <button type="button" class="btn btn-sm btn-info">New Import</button>
    </div>
    <span class="badge record-badge">{{ importObj.records }}</span>
    records were successfully imported.
  </div>
}

  <!-- View Batch Processes (always visible) -->
  <div class="import-right">
    <div class="btn-group" (click)="openBatchList()">
      <button type="button" class="btn btn-sm btn-dark-icon">
        <i class="fa fa-list"></i>
      </button>
      <button type="button" class="btn btn-sm btn-default batch-btn">View Batch Processes</button>
    </div>
  </div>

  <div class="import-doc-btn" (click)="openDocument()" title="Screen Documents">
    <i class="fa fa-file"></i>
  </div>

  <div class="clearfix"></div>
</div>
}

@if (showCancelConfirmModal) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="cancelConfirmConfig"
    [visible]="false"
    (confirmed)="onCancelDataLoadConfirmYes()"
    (cancelled)="onCancelDataLoadConfirmNo()"
    (closed)="onCancelDataLoadConfirmNo()">
  </gtw-confirmation-modal>
</div>
}
